// Sketch Categories Data - Organized for Supabase Migration
// Table: sketch_categories

export const SKETCH_CATEGORIES = [
  {
    id: "basic-2d-shapes",
    name: "Basic 2D Shapes",
    description: "Fundamental two-dimensional geometric shapes",
    icon: "square",
    color: "blue",
    order: 1,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "3d-shapes",
    name: "3D Shapes",
    description: "Three-dimensional geometric shapes and structures",
    icon: "cube",
    color: "purple",
    order: 2,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "3d-geometry",
    name: "3D Geometry",
    description: "Advanced three-dimensional geometric concepts",
    icon: "box",
    color: "indigo",
    order: 3,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "conic-sections",
    name: "Conic Sections",
    description: "Curves formed by intersecting a cone with a plane",
    icon: "circle",
    color: "green",
    order: 4,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "angle-geometry",
    name: "Angle Geometry",
    description: "Geometric constructions involving angles and measurements",
    icon: "angle",
    color: "orange",
    order: 5,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "circle-geometry",
    name: "Circle Geometry",
    description: "Advanced circle theorems and properties",
    icon: "circle",
    color: "teal",
    order: 6,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "theorem-geometry",
    name: "Theorem Geometry",
    description: "Mathematical theorems and proofs in geometry",
    icon: "book-open",
    color: "red",
    order: 7,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "function-analysis",
    name: "Function Analysis",
    description: "Mathematical functions and their properties",
    icon: "trending-up",
    color: "pink",
    order: 8,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "navigation-geometry",
    name: "Navigation Geometry",
    description: "Geometric concepts in navigation and bearings",
    icon: "compass",
    color: "yellow",
    order: 9,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "geometry-constructions",
    name: "Geometry Constructions",
    description: "Complex geometric constructions and combinations",
    icon: "ruler",
    color: "gray",
    order: 10,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "generated-from-image",
    name: "Generated from Image",
    description: "AI-generated sketches from uploaded images",
    icon: "camera",
    color: "emerald",
    order: 11,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "imported-sketches",
    name: "Imported Sketches",
    description: "Sketches imported from JSON files",
    icon: "download",
    color: "cyan",
    order: 12,
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  }
];

export const getCategoryById = (id) => {
  return SKETCH_CATEGORIES.find(category => category.id === id);
};

export const getCategoryByName = (name) => {
  return SKETCH_CATEGORIES.find(category => category.name === name);
};
